import Sop from './Sop';
export { default as SopPage } from './SopPage';
export default Sop;
